declare const window: any;
declare const RFE: any;


export class optim_ev {
    private firstScroll = true;
    private scrollEndTimer: any;
    private scrollStartTimer: any;
    private position: number;
    private down: boolean;
    private distDiff: number;
    private throttling = false;
    private throtTimer: any;
    private throtDelay: number;

    /**
     * Initialization of module. This module is expected to be used as single instance on page.
     * @return  {boolean}      TRUE/FALSE if the initialization was successful or not (boolean)
     */
    public initGlobal(): void {
        setTimeout(() => {
            this.position = window.pageYOffset;
            window.addEventListener('scroll', this.onScroll);
        }, 0)
    }
    /**
     * De-initialization of module
     */
    public deinitGlobal(): void {
        window.removeEventListener('scroll', this.onScroll);
        clearTimeout(this.scrollEndTimer);
        clearTimeout(this.scrollStartTimer);
        clearTimeout(this.throtTimer);
    }

    /**
     * scroll event handler
     */
    private onScroll = (e: Event): void => {
        this.distDiff = this.position - window.pageYOffset;
        if (this.firstScroll) {
            this.throtDelay = 30;
            this.position = window.pageYOffset;
            this.firstScroll = false;
            this.scrollStartTimer = setTimeout( (): void => {
                if (this.distDiff) {
                    this.direction();
                    RFE.triggerCustomEvent(window, 'scrollStartRfe', {detail: {downDirection: this.down, pageYOffset: this.position}});
                }
            }, 30);
        }
        else {
            this.throtDelay = 300;
        }

        if (!this.throttling) {
            this.throttling = true;
            this.throtTimer = setTimeout( () => {
                this.position = window.pageYOffset;
                if (this.distDiff) {
                    this.direction();
                    RFE.triggerCustomEvent(window, 'scrollThrotleRfe', {detail: {downDirection: this.down, pageYOffset: this.position}});
                }
                this.throttling = false;
            }, this.throtDelay)
        }

        clearTimeout(this.scrollEndTimer);
        this.scrollEndTimer = setTimeout( () => {
            this.scrollEnd();
        }, 60);
    }

    /**
     * triggered when scrolling ends
     */
    private scrollEnd = (): void => {
        this.position = window.pageYOffset;
        this.firstScroll = true;
        this.direction();
        RFE.triggerCustomEvent(window, 'scrollEndRfe', {detail: {downDirection: this.down, pageYOffset: this.position}});
    }

    /**
     * decides which way the scroll happened vertically and sets this.down
     */
    private direction = (): void => {
        if ( this.distDiff < 0 ) {
            this.down = true;
        }
        else {
            this.down = false;
        }
    }
}

const optimEvs = new optim_ev();
export default optimEvs;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./source/js/helpers/optim_events.ts